import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","align-items":"center","margin-left":"0","margin-right":"0","padding-left":"0","padding-right":"0"}
}
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isViewFollowButton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFollowButton && _ctx.onFollowButton(...args))),
          class: "btn btn-link"
        }, [
          (_ctx.dtoUser.isFollowedByLoginUser)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, "フォロー中"))
            : (_openBlock(), _createElementBlock("small", _hoisted_3, "フォローする"))
        ])
      ]))
    : _createCommentVNode("", true)
}